(function () {
  var selector = '[data-klaviyo-waitlist] form';

  function getField(form, name) {
    var field = form.querySelector('[name="' + name + '"]');
    return field ? field.value.trim() : '';
  }

  function renderMessage(container, form, message, type) {
    var current = container.querySelector('[data-klaviyo-waitlist-message]');
    if (current) {
      current.remove();
    }

    var element = document.createElement('p');
    element.setAttribute('data-klaviyo-waitlist-message', type);
    element.setAttribute('role', type === 'success' ? 'status' : 'alert');
    element.textContent = decodeMessage(message);
    element.className = 'klaviyo-waitlist-message';
    element.style.cssText = 'margin:12px 0 0;font-size:14px;line-height:1.4;font-weight:600;color:' + (type === 'success' ? '#0e7f3c' : '#a94600') + ';';
    form.appendChild(element);
  }

  function decodeMessage(message) {
    var textarea = document.createElement('textarea');
    textarea.innerHTML = message;
    return textarea.value;
  }

  function setFormState(form, disabled) {
    form.setAttribute('aria-busy', String(disabled));
    form.querySelectorAll('input, button').forEach(function (element) {
      element.disabled = disabled;
    });
  }

  function hideFields(form) {
    form.querySelectorAll('[data-klaviyo-waitlist-fields], [data-klaviyo-waitlist-tester], .ladyspot-launch-popup__waitlist-fields, .popup__waitlist-fields').forEach(function (fields) {
      fields.hidden = true;
    });
  }

  function rememberSubscription() {
    try {
      if (window.localStorage) {
        window.localStorage.setItem('spotmate-ladyspot-waitlist-subscribed', 'true');
      }
    } catch (error) {
      return;
    }
  }

  function trackSuccess(container) {
    var source = container.getAttribute('data-klaviyo-source') || 'LADYSPOT Launch Popup';
    var formLocation = container.getAttribute('data-spotmate-location') || 'ladyspot_launch_popup';
    var sectionId = container.getAttribute('data-spotmate-section') || 'unknown';

    if (window.SpotmateTracking && typeof window.SpotmateTracking.push === 'function') {
      window.SpotmateTracking.push(
        'ladyspot_waitlist_subscribe',
        {
          source: source,
          form_location: formLocation,
          section_id: sectionId
        },
        {
          dedupeKey: (container.getAttribute('data-klaviyo-list-id') || 'waitlist') + ':' + source,
          dedupeWindowMs: 30000
        }
      );
      return;
    }

    var trackingEvent = {
      event: 'ladyspot_waitlist_subscribe',
      source: source,
      form_location: formLocation,
      section_id: sectionId
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(trackingEvent);
    if (typeof window.spotmateGtmPush === 'function') {
      window.spotmateGtmPush(trackingEvent);
    }
  }

  async function subscribe(container, form) {
    var companyId = container.getAttribute('data-klaviyo-company-id');
    var listId = container.getAttribute('data-klaviyo-list-id');
    var testerListId = container.getAttribute('data-klaviyo-tester-list-id');
    var email = getField(form, 'contact[email]');
    var customSource = container.getAttribute('data-klaviyo-source') || 'LADYSPOT Launch Popup';
    var launchTester = form.querySelector('[name="launch_tester_video_interest"]');

    if (!companyId || !listId || !email) {
      throw new Error('missing_required_fields');
    }

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: customSource,
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: listId
            }
          }
        }
      }
    };

    var properties = window.SpotmateSubscriptionContext ? window.SpotmateSubscriptionContext.properties(container) : {};
    if (launchTester && launchTester.checked) properties.ladyspot_launch_tester_video_interest = true;
    payload.data.attributes.profile.data.attributes.properties = properties;

    var response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: '2024-07-15'
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok && response.status !== 202) {
      throw new Error('klaviyo_' + response.status);
    }

    if (launchTester && launchTester.checked && testerListId && testerListId !== listId) {
      payload.data.attributes.custom_source = customSource + ' - Video Agreed';
      payload.data.relationships.list.data.id = testerListId;

      var testerResponse = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          revision: '2024-07-15'
        },
        body: JSON.stringify(payload)
      });

      if (!testerResponse.ok && testerResponse.status !== 202) {
        throw new Error('klaviyo_tester_' + testerResponse.status);
      }
    }
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches(selector)) {
      return;
    }

    var container = form.closest('[data-klaviyo-waitlist]');
    if (!container) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.getAttribute('aria-busy') === 'true') return;
    if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
      if (typeof form.reportValidity === 'function') {
        form.reportValidity();
      }
      return;
    }
    setFormState(form, true);

    subscribe(container, form)
      .then(function () {
        hideFields(form);
        renderMessage(container, form, container.getAttribute('data-klaviyo-success') || 'You are on the list.', 'success');
        rememberSubscription();
        trackSuccess(container);
      })
      .catch(function () {
        renderMessage(container, form, container.getAttribute('data-klaviyo-error') || 'Something went wrong. Please try again.', 'error');
        setFormState(form, false);
      });
  }, true);
})();
